export default "__VITE_ASSET__CWjYvKR9__"